const selectors = {
  multipleBlocks: '[data-multiple-blocks]',
  storyBlock: '[data-story-block]',
  storyInlinePlayPause: '[data-play-pause]',
  storyInlineVideo: '[data-inline-video]',
  storyModal: '[data-modal]',
  storyModalBackdrop: '[data-modal-backdrop]',
  storyModalClose: '[data-modal-close]',
  storyModalOpen: '[data-modal-open]',
  storyModalVideo: '[data-modal-video]',
  storySectionBlocks: '[data-story-section-block]',
};

const dom = {};

const cacheDom = () => {
  dom.storyBlocks = document.querySelectorAll(selectors.storyBlock);
};

const openModal = (modal) => {
  modal.classList.add('active');

  // Lock Body scroll
  document.body.classList.add('overflow-hidden');
};

const closeModal = (modal) => {
  modal.classList.remove('active');

  // Unlock Body scroll
  document.body.classList.remove('overflow-hidden');
};

const playPause = (playBtn, video) => {
  if (video.classList.contains('paused')) {
    video.play();
    video.classList.remove('paused');
    playBtn.classList.remove('paused');
  } else {
    video.pause();
    video.classList.add('paused');
    playBtn.classList.add('paused');
  }
};

const videoFinished = (playBtn, video) => {
  video.classList.add('paused');
  playBtn.classList.add('paused');
};

const isInViewport = (el) => {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

const initBlock = (storyBlock) => {
  const thisStoryBlock = storyBlock;
  const modal = thisStoryBlock.querySelector(selectors.storyModal);
  const inlineVideo = thisStoryBlock.querySelector(selectors.storyInlineVideo);

  if (inlineVideo) {
    const storyInlinePlayPause = thisStoryBlock.querySelector(
      selectors.storyInlinePlayPause,
    );
    let playVideoOnce = true;

    storyInlinePlayPause.addEventListener('click', (event) => {
      playPause(storyInlinePlayPause, inlineVideo);
    });

    // Autoplay the video one time when in viewport
    document.addEventListener('scroll', () => {
      const videoIsVisible = isInViewport(inlineVideo);

      if (videoIsVisible && playVideoOnce) {
        playVideoOnce = false;

        playPause(storyInlinePlayPause, inlineVideo);
      }
    });

    // Check if the video finished and put paused states
    inlineVideo.addEventListener('ended', (e) => {
      videoFinished(storyInlinePlayPause, inlineVideo);
    });
  }

  if (modal) {
    const modalOpen = thisStoryBlock.querySelector(selectors.storyModalOpen);
    const modalClose = thisStoryBlock.querySelector(selectors.storyModalClose);
    const modalBackdrop = thisStoryBlock.querySelector(
      selectors.storyModalBackdrop,
    );
    const modalVideo = thisStoryBlock.querySelector(selectors.storyModalVideo);

    modalOpen &&
      modalOpen.addEventListener('click', (event) => {
        openModal(modal);
      });

    modalClose &&
      modalClose.addEventListener('click', (event) => {
        closeModal(modal);
        modalVideo.setAttribute('src', modalVideo.getAttribute('src'));
      });

    modalBackdrop &&
      modalBackdrop.addEventListener('click', (event) => {
        closeModal(modal);
        modalVideo.setAttribute('src', modalVideo.getAttribute('src'));
      });
  }
};

const initSectionBlock = (storyBlock) => {
  const thisStoryBlock = storyBlock;

  const modalId = thisStoryBlock.dataset.storySectionBlock;

  const modal = document.querySelector('[data-modal="' + modalId + '"]');
  const inlineVideo = thisStoryBlock.querySelector(selectors.storyInlineVideo);

  if (inlineVideo) {
    const storyInlinePlayPause = thisStoryBlock.querySelector(
      selectors.storyInlinePlayPause,
    );
    let playVideoOnce = true;

    storyInlinePlayPause.addEventListener('click', (event) => {
      playPause(storyInlinePlayPause, inlineVideo);
    });

    // Autoplay the video one time when in viewport
    document.addEventListener('scroll', () => {
      const videoIsVisible = isInViewport(inlineVideo);

      if (videoIsVisible && playVideoOnce) {
        playVideoOnce = false;

        playPause(storyInlinePlayPause, inlineVideo);
      }
    });

    // Check if the video finished and put paused states
    inlineVideo.addEventListener('ended', (e) => {
      videoFinished(storyInlinePlayPause, inlineVideo);
    });
  }

  if (modal) {
    const modalOpen = thisStoryBlock.querySelector(selectors.storyModalOpen);
    const modalClose = modal.querySelector(selectors.storyModalClose);
    const modalBackdrop = modal.querySelector(selectors.storyModalBackdrop);
    const modalVideo = modal.querySelector(selectors.storyModalVideo);

    modalOpen.addEventListener('click', (event) => {
      openModal(modal);
    });

    modalClose.addEventListener('click', (event) => {
      closeModal(modal);
      modalVideo.setAttribute('src', modalVideo.getAttribute('src'));
    });

    modalBackdrop.addEventListener('click', (event) => {
      closeModal(modal);
      modalVideo.setAttribute('src', modalVideo.getAttribute('src'));
    });
  }
};

const handleStoryModalEvents = () => {
  if (dom.storyBlocks) {
    dom.storyBlocks.forEach((storyBlock) => {
      //Check if the section uses blocks or its simple
      //[Single story] is simple
      //[Two story] allows for blocks
      const hasMultiple = storyBlock.querySelector(selectors.multipleBlocks);

      if (hasMultiple) {
        const storySectionBlocks = storyBlock.querySelectorAll(
          selectors.storySectionBlocks,
        );

        storySectionBlocks.forEach((storySectionBlock) => {
          initSectionBlock(storySectionBlock);
        });
      } else {
        initBlock(storyBlock);
      }
    });
  }
};

const storyBlockModal = {
  init() {
    cacheDom();
    handleStoryModalEvents();
  },
};

export default storyBlockModal;
